'use strict';

const jQuery = require('jquery');

const Zone = require('./../../../../services/structure/zone');
const Translator = require('./../../../../core/translator');
const Mediator = require('./../../../../core/mediator');
const Container = require('./../../../../core/container');
const Loader = require('./../../../../services/loader');
const PopinManager = require('./../../../../services/popin');
const Overlay = require('./../../../../services/overlay');
const FormBuilder = require('./../../../../services/form');
const SaveManager = require('./../../component/SaveManager');

const ContentRepository = require('./../../repository/ContentRepository');
const MediaRepository = require('./../../repository/MediaRepository');
const UploadPlugin = require('./../../plugin/upload');

const fullPanelTpl = require('./template/full_panel.hbs');
const itemTpl = require('./template/item.hbs');

let $fullPanelContainer;
let $itemWrapper;
let searchData = {};

const PAGINATION_STEP = 30;

const getSmallPanelContent = () => {
    return jQuery('<p></p>');
};

const showOverlay = () => {
    Overlay.show({
        'onClick': function() {
            return;
        },
        'classes': 'medialibrary-overlay',
        'appender': $fullPanelContainer,
    });
};

const closeOverlay = () => {
    jQuery('.medialibrary-overlay').remove();
};

const cleanSearch = () => {
    searchData = {};
};

const showMediaForm = (mediaData) => {
    let popin;
    let $container = jQuery('<div />');
    let uploadInfo = {
        base64: null,
        name: null,
    };

    let form = FormBuilder.getForm({
        elements: {
            title: {
                label: Translator.translate('media_title') + '*',
                type: 'text',
                value: mediaData.title,
            },
            description: {
                label: Translator.translate('media_description'),
                type: 'textarea',
                value: mediaData.description,
            },
            copyright: {
                label: Translator.translate('media_copyright'),
                type: 'text',
                value: mediaData.copyright || '',
            },
           /* tags: {
                label: Translator.translate('media_tags'),
                type: 'textList',
                value: mediaData.tags || [],
            },*/
            file: {
                description: Translator.translate('file') + '*',
                type: 'upload',
                forceLocal: true,
                acceptedFiles: 'image/*',
                value: mediaData['image_url'] || '',
                forceResizeImage: true,
                notModifyUrl: true,
                useUrl: true,
                afterUpload: (response, base64, file) => {
                    uploadInfo.base64 = base64.replace(new RegExp('^data:' + file.type + ';base64,', 'g'), '');
                    uploadInfo.name = file.name;
                },
            },
        },
        form: {
            'submit_class': 'd-none',
            'form_class': 'mb-0',
        },
    });

    form.on('validate', (data) => {
        if (!data.file) {
            form.addError('file', Translator.translate('missing_file'));
            popin.rootElement.scrollTop(500);
        }

        if (!data.title) {
            form.addError('title', Translator.translate('missing_title'));
        }
    });

    form.on('submit', (data) => {
        delete data.file;
        data.tags = [];

        if (uploadInfo.base64) {
            data.filename = uploadInfo.name;
            data.content = uploadInfo.base64;
        }

        Loader.start(popin.rootElement);

        if (mediaData && mediaData.uid) {
            MediaRepository.edit(data, mediaData.uid).done(() => {
                cleanSearch();
                showList({}, true);
                popin.hide();
            });
        } else {
            MediaRepository.post(data).done(() => {
                cleanSearch();
                showList({}, true);
                popin.hide();
            });
        }
    });

    popin = PopinManager.createPopin({
        title: Translator.translate(mediaData && mediaData.uid ? 'media_edit' : 'media_create'),
        position: {my: 'center center', at: 'center center', of: jQuery('.cloud-panel-fullpage')},
        width: 500,
        height: 500,
        buttons: [
            {
                class: 'popin popin-cancel',
                text: Translator.translate('discard'),
                click: function() {
                    form.dispatch('cancel');
                    popin.hide();
                },
            },
            {
                class: 'popin popin-ok',
                text: Translator.translate('submit'),
                click: function() {
                    form.submit();
                },
            },
        ],
    });

    popin.on('open', showOverlay);
    popin.on('close', closeOverlay);

    $container.append(form.render());
    $container.append(`<p>*${Translator.translate('media_required_fields')}</p>`);

    popin.setContent($container);

    popin.display();
};

const showList = (config = {}, clean = false) => {
    let searchConfig = {};
    let $row = $itemWrapper.find('.cloud-row');

    if (searchData.term) {
        searchConfig.term = searchData.term;
    }

    if (!(searchData.start !== undefined && searchData.end !== undefined)) {
        searchData.start = 0;
        searchData.end = PAGINATION_STEP;
    }

    searchConfig.range = `${searchData.start}-${searchData.end}`;

    Loader.start($fullPanelContainer);
    MediaRepository.findBy(searchConfig).done(function(medias) {
        if (clean) {
            $row.html('');
        }

        medias.forEach((media, key) => {
            media.disableShow = config.disableShow;
            media.disableDelete = config.disableDelete;
            media.disableAll = media.disableShow && media.disableDelete;

            let $item = jQuery(itemTpl(media));

            $item.on('click', '.edit-media-btn', () => {
                showMediaForm(media);
            });
            $item.on('click', function() {
                if (typeof config.onItemClick === 'function') {
                    config.onItemClick(media);
                }
            });

            $item.on('click', '.del-media-btn', function() {
                showDeletePopin(media);
            });

            $row.append($item);
        });

        Loader.stop($fullPanelContainer);
    });
};

const showDeletePopin = (media) => {
    let popin = PopinManager.createPopin({
        title: Translator.translate('delete_media_popin_title'),
        position: {my: 'center center', at: 'center center', of: jQuery('.cloud-panel-fullpage')},
        width: 500,
        buttons: [
            {
                class: 'popin popin-cancel',
                text: Translator.translate('discard'),
                click: function() {
                    popin.hide();
                },
            },
            {
                class: 'popin popin-ok',
                text: Translator.translate('submit'),
                click: function() {
                    Loader.start(popin.rootElement);
                    MediaRepository.delete(media.uid).done(() => {
                        showList({}, true);
                        popin.hide();
                    });
                },
            },
        ],
    });

    popin.setContent(`<p>${Translator.translate('delete_media_popin_content')}</p>`);

    popin.display();
};

const bindSearchEvent = (config) => {
    let $input = $fullPanelContainer.find('.search-input');

    $input.on('keyup', function() {
        let term = jQuery.trim($input.val().replace(/[\/\\"]/gi, ' ')).replace(/\s+/g, ' ');

        cleanSearch();
        searchData.term = term;

        showList(config, true);
    });
};

const getFullPanelContent = (config = {}) => {
    $fullPanelContainer = jQuery(fullPanelTpl());
    $itemWrapper = $fullPanelContainer.find('.item-wrapper');

    let $createBtn = $fullPanelContainer.find('.create-media');

    bindSearchEvent(config);

    if (config.disableCreate) {
        $createBtn.addClass('d-none');
    } else {
        $fullPanelContainer.find('.create-media').on('click', showMediaForm);
    }

    $itemWrapper.on('scroll', function() {
        if($itemWrapper.scrollTop() + $itemWrapper.innerHeight() >= $itemWrapper[0].scrollHeight) {
            searchData.start = searchData.end + 1;
            searchData.end = searchData.start + PAGINATION_STEP;

            showList(config);
        }
    });

    cleanSearch();

    showList(config);

    return $fullPanelContainer;
};

const isEnabled = () => {
    return Container.get('$toolbar').attr('data-media-center-enable') === 'true';
};

module.exports.isEnabled = isEnabled;

module.exports.beforeRenderUpload = (data) => {
    if (isEnabled()) {
        data.$tpl.find('.upload-menu').append(`<li class="nav-item" data-tab="medialibrary"><span class="nav-link">${Translator.translate('medialibrary')}</span></li>`);
        data.$tpl.find('.tab-wrapper').append(jQuery(`<div class="tab tab-medialibrary d-none" />`).append(getFullPanelContent({
            disableDelete: true,
            disableShow: true,
            disableCreate: true,
            onItemClick: function(media) {
                let {content} = data;
                let $tabMedia = data.$tpl.find('.tab-wrapper').find('.tab-medialibrary');
                let resource = {
                    originalname: media.filename,
                    src: `media-center:${media['image_url']}`,
                };

                Loader.start($tabMedia);

                ContentRepository.upload(resource).done((response) => {
                    if (typeof data.onMediaClick === 'function') {
                        data.onMediaClick(response).then(() => {
                            data.popin.hide();
                        });
                    } else {
                        UploadPlugin.updateFileOfMedia(content, response).done(() => {
                            SaveManager.save().done(() => {
                                content.refresh().done(() => {
                                    Mediator.publish('after:upload', content);
                                    Loader.stop(content.$);
                                    data.popin.hide();
                                });
                            });
                        });
                    }
                });
            },
        })));
    }
};

module.exports.init = () => {
    Zone.setSmallPanel(Translator.translate('medialibrary'), getSmallPanelContent());
    Zone.setFullPanel(Translator.translate('medialibrary'), getFullPanelContent());
};
